import script from "./ClientsPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsPartners.vue?vue&type=script&setup=true&lang=js"

import "./ClientsPartners.vue?vue&type=style&index=0&id=17e4e1e5&lang=scss&scoped=true"

import exportComponent from "/home/islam/works/billing-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e4e1e5"]])

export default __exports__